// front/src/preview-mode/graph/devices.ts
import type { Rng } from "./seed";
import type { PreviewDevice } from "./types";

const USER_AGENTS = [
  "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/122.0.0.0 Safari/537.36",
  "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/17.2 Safari/605.1.15",
  "Mozilla/5.0 (iPhone; CPU iPhone OS 17_2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/17.2 Mobile/15E148 Safari/604.1",
  "Mozilla/5.0 (Linux; Android 14; Pixel 8) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/122.0.0.0 Mobile Safari/537.36",
  "Mozilla/5.0 (iPad; CPU OS 17_2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/17.2 Mobile/15E148 Safari/604.1",
  "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.0.0 Safari/537.36 Edg/121.0.0.0",
];

interface RegionEntry {
  region: string;
  city: string;
  county: string;
  zips: string[];
}

const REGIONS: RegionEntry[] = [
  {
    region: "IL",
    city: "Chicago",
    county: "Cook County",
    zips: ["60601", "60607", "60614", "60622", "60642"],
  },
  {
    region: "IL",
    city: "Naperville",
    county: "DuPage County",
    zips: ["60540", "60563", "60564"],
  },
  {
    region: "IL",
    city: "Aurora",
    county: "Kane County",
    zips: ["60502", "60505", "60506"],
  },
  {
    region: "IL",
    city: "Rockford",
    county: "Winnebago County",
    zips: ["61101", "61103", "61107"],
  },
  {
    region: "WI",
    city: "Milwaukee",
    county: "Milwaukee County",
    zips: ["53202", "53204", "53211", "53215"],
  },
  {
    region: "WI",
    city: "Madison",
    county: "Dane County",
    zips: ["53703", "53705", "53711", "53715"],
  },
  {
    region: "WI",
    city: "Green Bay",
    county: "Brown County",
    zips: ["54301", "54302", "54303", "54311"],
  },
  {
    region: "IN",
    city: "Indianapolis",
    county: "Marion County",
    zips: ["46201", "46202", "46204", "46205", "46225"],
  },
  {
    region: "IN",
    city: "Fort Wayne",
    county: "Allen County",
    zips: ["46802", "46805", "46815", "46825"],
  },
  {
    region: "IN",
    city: "South Bend",
    county: "St. Joseph County",
    zips: ["46601", "46613", "46614", "46615"],
  },
];

const FIRST_NAMES = [
  "james",
  "mary",
  "robert",
  "patricia",
  "john",
  "jennifer",
  "michael",
  "linda",
  "david",
  "elizabeth",
  "william",
  "barbara",
  "richard",
  "susan",
  "joseph",
  "jessica",
  "thomas",
  "sarah",
  "charles",
  "karen",
  "daniel",
  "nancy",
  "matthew",
  "lisa",
  "anthony",
  "betty",
];

const LAST_NAMES = [
  "smith",
  "johnson",
  "williams",
  "brown",
  "jones",
  "garcia",
  "miller",
  "davis",
  "rodriguez",
  "martinez",
  "hernandez",
  "lopez",
  "gonzalez",
  "wilson",
  "anderson",
  "thomas",
  "taylor",
  "moore",
  "jackson",
  "martin",
  "lee",
  "perez",
  "thompson",
  "white",
  "harris",
];

export const DEVICE_COUNT = 800;
export const IDENTIFIED_FRACTION = 0.4;

export function generateDevices(rng: Rng): PreviewDevice[] {
  const devices: PreviewDevice[] = [];
  for (let i = 0; i < DEVICE_COUNT; i++) {
    const ua = rng.pick(USER_AGENTS);
    const loc = rng.pick(REGIONS);
    const ip = `${73 + rng.int(30)}.${rng.int(256)}.${rng.int(256)}.${rng.int(256)}`;
    let identifier: string | undefined;
    if (rng.next() < IDENTIFIED_FRACTION) {
      const first = rng.pick(FIRST_NAMES);
      const last = rng.pick(LAST_NAMES);
      identifier = `${first}.${last}@example.com`;
    }
    devices.push({
      deviceID: rng.uuid(),
      userAgent: ua,
      ipAddress: ip,
      countryCode: "US",
      region: loc.region,
      city: loc.city,
      county: loc.county,
      zipCode: rng.pick(loc.zips),
      identifier,
    });
  }
  return devices;
}
